import { useState, useEffect } from 'react';
import { MOBILE_MEDIA_QUERY } from '../constants/breakpoints';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_MEDIA_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    const mqListener = (e) => setIsMobile(e.matches);

    setIsMobile(mq.matches);
    mq.addEventListener('change', mqListener);

    return () => {
      mq.removeEventListener('change', mqListener);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
